<template>
  <div>
    <v-simple-table fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center" style="width: 50px">ID</th>
            <th class="text-left">名前</th>
            <th v-if="adminTable">権限</th>
            <th class="text-left">登録メールアドレス</th>
            <th class="text-left">最終ログイン日時</th>
            <th class="text-left">プロフィール</th>
            <th class="text-left">アカウントの凍結</th>
            <th>ライターページ</th>
            <th class="text-left" />
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users.filter((user) => user.userAuth)"
            :key="user.id"
          >
            <td class="text-center">
              {{ user.id }}
            </td>
            <td v-if="isUserInviting(user)">
              <v-chip small> 招待中 </v-chip>
              <v-btn small text plain color='primary' @click="reinviteUserAuth(user.userAuth.id)"
                >招待メールを再送する</v-btn
              >
            </td>
            <td v-else>
              {{ user.name }}
            </td>
            <td v-if="adminTable">{{ user.roleName }}</td>
            <td>{{ user.userAuth.email }}</td>
            <td>
              {{ user.userAuth.currentSignInAt | moment }}
            </td>
            <td>
              <router-link
                :to="{ name: 'editWriter', params: { id: user.id } }"
              >
                <v-btn color="primary" tile small> 編集する </v-btn>
              </router-link>
            </td>
            <td>
              <template v-if="!isUserInviting(user)">
                <v-btn v-if="user.id == currentUser.id" disabled tile small>
                  ログイン中
                </v-btn>
                <v-btn
                  v-else-if="user.isActive"
                  color="primary"
                  tile
                  small
                  @click="accountSuspension(user.id)"
                >
                  凍結する
                </v-btn>
                <v-btn
                  v-else
                  color="normal"
                  tile
                  small
                  @click="accountSuspension(user.id)"
                >
                  凍結を解除する
                </v-btn>
              </template>
            </td>
            <td class="text-center">
              <v-chip v-if="user.writerPagePublished" small>公開</v-chip>
              <v-chip v-else small>非公開</v-chip>
            </td>
            <td>
              <v-btn
                v-if="
                  adminTable &&
                  currentUser.permittedSituations.includes('admin_role_update')
                "
                class="ma-2"
                tile
                outlined
                small
                color="warning"
                @click="editAdminRole(user.id)"
              >
                <v-icon left small> mdi-cog </v-icon>
                権限変更
              </v-btn>
            </td>
            <td>
              <template v-if="!isUserInviting(user)">
                <v-btn
                  v-if="user.official"
                  color="teal"
                  small
                  tile
                  class="white--text"
                  @click="userOfficialize(user.id)"
                >
                  非公式にする
                </v-btn>
                <v-btn
                  v-else
                  color="normal"
                  tile
                  small
                  @click="userOfficialize(user.id)"
                >
                  公式にする
                </v-btn>
              </template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="editDialog" max-width="300">
      <v-card v-if="editUser">
        <v-card-title> 管理者権限変更 </v-card-title>
        <v-card-text>
          <v-form>
            権限
            <v-select
              v-model="editUser.roleAttributes"
              :items="roles"
              class="body-2"
              item-text="name"
              style="width: 200px"
              return-object
              flat
              dense
              single-line
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" text small @click="editDialog = false">
            キャンセル
          </v-btn>
          <v-btn color="green darken-1" text small @click="updateAdminRole">
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex'
import { deserialize } from 'deserialize-json-api'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    adminTable: {
      type: Boolean,
      required: true
    }
  },
  data: () => {
    return {
      page: 1,
      invitationDialog: false,
      editDialog: false,
      roles: [],
      editUser: null
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  mounted: function () {
    axios.get('/api/roles').then(
      ({ data }) => {
        data.roles.forEach((role) => this.roles.push(role))
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.message
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    editAdminRole (userId) {
      if (!this.adminTable) {
        return true
      }

      axios.get(`/api/admin_users/${userId}/roles/edit`).then(
        ({ data }) => {
          this.editUser = data.data.attributes
          this.editDialog = true
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    updateAdminRole () {
      if (!this.adminTable) {
        return true
      }

      const query = { roleAttributes: this.editUser.roleAttributes }
      axios.patch(`/api/admin_users/${this.editUser.id}/roles`, query).then(
        ({ data }) => {
          const updatedAdmin = data.data.attributes
          const adminUser = this.users.find(
            (admin) => admin.id === updatedAdmin.id
          )
          Object.assign(adminUser, updatedAdmin)
          const payload = {
            status: 200,
            message: '権限を更新しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
      this.editDialog = false
    },
    accountSuspension (userId) {
      axios.patch(`/api/account_suspension/${userId}`).then(
        ({ data }) => {
          const deserializedData = deserialize(data).data
          const index = this.users.findIndex((v) => v.id === userId)
          this.users.splice(index, 1, deserializedData)
          const text = deserializedData.isActive
            ? 'アカウントを再開しました'
            : 'アカウントを停止しました'
          const payload = {
            status: 200,
            message: text
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    userOfficialize (userId) {
      axios.patch(`/api/user_officialize/${userId}`).then(
        ({ data }) => {
          const deserializedData = deserialize(data).data
          const index = this.users.findIndex((v) => v.id === userId)
          this.users.splice(index, 1, deserializedData)
          const text = deserializedData.official
            ? '公式にしました'
            : '非公式にしました'
          const payload = {
            status: 200,
            message: text
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    isUserInviting (user) {
      return (
        user.userAuth.invitationSentAt &&
        user.userAuth.invitationAcceptedAt == null
      )
    },
    reinviteUserAuth (userAuthId) {
      this.$emit('reinvite-user-auth', userAuthId)
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
